module.exports = __webpack_public_path__ + "img/takeLeave_4_zh.50c36e40.png";